import React from "react";
import "styles/siteChrome.css";
import "./programsPage.css";

const OFFICE_PHONE = "502-252-8512";
const OFFICE_EMAIL = "office@ace-gymnastics.com";

const ProgramsEmptySchedule = ({ categoryTitle }) => (
  <div className="programs-empty-schedule">
    <p className="programs-empty-schedule__message">
      No classes are listed online
      {categoryTitle ? ` for ${categoryTitle}` : ""} right now.
    </p>
    <p className="programs-empty-schedule__hint">
      Our team can share the latest schedule and help you register or join a
      waitlist.
    </p>
    <div className="programs-empty-schedule__actions">
      <a href={`tel:${OFFICE_PHONE.replace(/-/g, "")}`} className="site-btn site-btn--accent">
        Call {OFFICE_PHONE}
      </a>
      <a
        href={`mailto:${OFFICE_EMAIL}?subject=Class schedule inquiry`}
        className="site-btn site-btn--outline programs-empty-schedule__email"
      >
        Email the office
      </a>
    </div>
  </div>
);

export default ProgramsEmptySchedule;
